import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: [],
    meta: {},
    loadingStatus: 'idle',
    error: null
}

export const fetchExport = createAsyncThunk(
    'exportData/fetchExport',
    async({token, params, page}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            };

            const response = await request(
                `${APP_URL}/reports/export?${params}&page=${page}`,
                'GET',
                null,
                customHeaders
            );

            return response;
        } catch (error) {
            console.log(error);
            rejectWithValue(error.status);
        }
    }
)

const exportSlice = createSlice({
    name: 'exportData',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchExport.pending, (state) => {
                state.loadingStatus = 'loading';
            })
            .addCase(fetchExport.fulfilled, (state, action) => {
                state.loadingStatus = 'idle';
                console.log("Ответ API, columns:", action.payload.columns);
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.meta = action.payload.meta;
            })
            .addCase(fetchExport.rejected, (state, action) => {
                state.loadingStatus = 'error';
                state.error = action.payload;
            })
    }
})

export default exportSlice.reducer;